import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { FundPerformanceHistory } from '../../Models/Models/PortfolioAnalysis/Investment/FundPerformanceHistory';

declare var IS_RUNNING_IN_APP_POOL;

export class FundsDiscretePerformanceClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(productId: number): Promise<Array<FundPerformanceHistory>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/FundsDiscretePerformance/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { productId: productId }

    return AjaxWrapper.get<Array<FundPerformanceHistory>, any>(url, data);
  }
}

